import DataTable from "../../../components/Table";
import type { ColumnsType } from "antd/es/table";
import { Row, Col, Button, Space, Popconfirm, message, Image } from "antd";
import { DeleteOutlined } from "@ant-design/icons";
import { useEffect, useState } from "react";
import { useAppDispatch, useAppSelector } from "../../../redux/hooks";
import AddPodcast from "./add";
import { callDeleteUpload } from "../../../config/api";
import ModalPodcast from "./edit";
import DateFormat from "../../../utils/formatTime/DateFormat";
import { FORMAT_DATE_DISPLAY } from "../../../utils/constants/timeFormat";
import ViewDetail from "./detail/ViewDetail";
import PodcastSearch from "./PodcastSearch";
import { fetchUpload } from "../../../redux/slice/uploadSlice";

function ManageUpload() {
  const [searchPagination, setSearchPagination] = useState(
    "current=1&pageSize=5"
  );
  const [searchData, setSearchData] = useState("");
  const dispatch = useAppDispatch();
  const listImage = useAppSelector((state) => state.upload);
  const [dataViewDetail, setDataViewDetail] = useState("");
  const [openViewDetail, setOpenViewDetail] = useState(false);

  const handleDeleteUpload = async (record: any) => {
    try {
      const res = await callDeleteUpload({ publicId: record?.public_id });
      if (res.statusCode === 200) {
        handleFetchUpload();
        message.success("Xóa ảnh thành công");
      }
    } catch (error) {}
  };

  const columns: ColumnsType<any> = [
    {
      title: "ID",
      dataIndex: "public_id",
      render: (text, record: any) => {
        return (
          <span
            style={{ color: "#4986ff", cursor: "pointer" }}
            onClick={() => {
              setDataViewDetail(record);
              setOpenViewDetail(true);
            }}>
            {text}
          </span>
        );
      },
    },
    {
      title: "Image",
      dataIndex: "secure_url",
      render: (text) => {
        return (
          <>
            <Image width={36} src={text} />
          </>
        );
      },
    },
    {
      title: "Link ảnh",
      dataIndex: "url",
      render: (text) => {
        return (
          <a
            style={{ color: "#5886ff" }}
            target="_blank"
            rel="noreferrer"
            href={text}>
            {text}
          </a>
        );
      },
    },
    {
      title: "CreatedAt",
      dataIndex: "createdAt",
      render: (text) => {
        return (
          <>
            <DateFormat time={text} format={FORMAT_DATE_DISPLAY} />
          </>
        );
      },
    },
    {
      title: "Action",
      key: "action",
      render: (_, record: any) => (
        <Space size="middle">
          <ModalPodcast
            detailUpload={record}
            handleFetchUpload={handleFetchUpload}
          />
          <Popconfirm
            placement="leftTop"
            title={"Xác nhận xóa user"}
            description={"Bạn có chắc chắn muốn xóa user này ?"}
            onConfirm={() => handleDeleteUpload(record)}
            okText="Xác nhận"
            cancelText="Hủy">
            <Button type="primary" danger ghost>
              <DeleteOutlined />
            </Button>
          </Popconfirm>
        </Space>
      ),
    },
  ];

  let query = `${searchPagination}${searchData}`;

  const handleFetchUpload = () => {
    dispatch(fetchUpload({ query }));
  };
  useEffect(() => {
    handleFetchUpload();
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [query]);

  const handleModalCreate = (): JSX.Element => {
    return (
      <>
        <AddPodcast handleFetchUpload={handleFetchUpload} />
      </>
    );
  };

  const handleSearch = (paramSearch: any) => {
    setSearchData(paramSearch);
  };

  return (
    <>
      <Row gutter={[20, 20]}>
        <Col span={24}>
          <PodcastSearch handleSearch={handleSearch} />
        </Col>
      </Row>
      <DataTable
        columns={columns}
        data={listImage?.result}
        loading={listImage.isFetching}
        total={listImage?.meta.total}
        modalAdd={handleModalCreate}
        name={"Categories"}
        setSearchPagination={setSearchPagination}
      />
      <ViewDetail
        openViewDetail={openViewDetail}
        dataViewDetail={dataViewDetail}
        setOpenViewDetail={setOpenViewDetail}
      />
    </>
  );
}

export default ManageUpload;
